module.exports = __webpack_public_path__ + "static/img/13.93baa54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/13.png
// module id = DIs9
// module chunks = 0